<template>
    <div class="card position-sticky mt-0 ps-4">
        <div class="card-header ps-5 p-0 pt-4 mb-0 pb-0" style="margin-bottom: 0 !important;" v-if="!editing && !insert">
            <div class="row">
                <div class="col-sm-12"> 
                    <button type="button" class="btn  me-2 mt-0 mb-0 bg-gradient-danger" @click="Delete()">
                        <span class="btn-text">
                            <i class="bi bi-trash3" style="font-weight:bolder;"></i>&nbsp;&nbsp;Ləğv</span>
                    </button>
                    <button type="button" class="btn  me-2 mt-0 mb-0" @click="Print()">
                        <span class="btn-text">
                            <i class="fa fa-file" style="font-weight:bolder;"></i>&nbsp;&nbsp;Çap</span>
                    </button>
                    <button type="button" class="btn  me-2 mt-0 mb-0">
                        <span class="btn-text">
                            <i class="fa fa-link" style="font-weight:bolder;"></i>&nbsp;&nbsp;Fayl</span>
                    </button>
                    <button type="button" class="btn  mt-0 mb-0" @click="GetData()">
                        <span class="btn-text">
                            <i class="fa fa-sync" style="font-weight:bolder;"></i>&nbsp;&nbsp;Yeniləmək</span>
                    </button><br><br>
                </div>
            </div>
        </div>
        <div class="card-body px-0 pt-2 pb-3" v-loading="loading">
            <Data :data="data"></Data>
        </div>
    </div>
    <Print v-show="false"></Print>
</template>
<script>  
import Data from "./Components/Data.vue"; 
import Print from './Components/Print.vue'

export default {
    props:{
        priv: Object
    },
    components: {
        Data, 
        Print
    },
    data() {
        return {
            data: { },
            loading: false,
            editing: false,
            insert: false
        }
    } 
}
</script>